<div class="swiper-container swiper-vip-user-reward">
    <div class="swiper-wrapper">
        <div class="swiper-slide">
        </div>
    </div>

    <div *ngIf="isMobile" class="swiper-pagination"></div>
    <div *ngIf="!isMobile" class="arrowbox">
        <div class="swiper-button-prev-test">
            <svg-icon src="./assets/images/svg-icons/left-page-arrow.svg"></svg-icon>
        </div>
        <div class="swiper-button-next-test">
            <div class="arrow-right">
                <svg-icon src="./assets/images/svg-icons/left-page-arrow.svg"></svg-icon>
            </div>
        </div>
    </div>

</div>
